import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=bb09a12c&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=bb09a12c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb09a12c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb09a12c')) {
      api.createRecord('bb09a12c', component.options)
    } else {
      api.reload('bb09a12c', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=bb09a12c&scoped=true&", function () {
      api.rerender('bb09a12c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2BUqyg5wWuhI0/JS/comp/SearchFilterTokens.vue"
export default component.exports